import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { clearUserInfo } from "../../store/auth/authSlice";
import { getShorthandName, isValidUrl } from "../../utils/Helper";
import { useNavigate } from "react-router-dom";
import { ReactComponent as DownArrowEnt } from "../../assets/icons/downArrowEnt.svg";
import { setClearClaimDetails } from "../../store/claim/claimSlice";

const UserProfileDropdown = ({ showDetails = false }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    userInfo: { name, profile_image, email },
  } = useSelector((state) => state.auth);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [isValidProfileImage, setIsValidProfileImage] = useState(false);

  useEffect(() => {
    if (profile_image) {
      const isValid = isValidUrl(profile_image);
      setIsValidProfileImage(isValid);
    }
  }, [profile_image])

  const handleDropdownToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    // const res = await fetch(`${process.env.REACT_APP_K_HUB_URL}/api/auth/logout`, {
    //   method: "POST",
    //   credentials: "include", // 👈 VERY important
    // });

    // const data = await res?.json();
    dispatch(setClearClaimDetails())
    dispatch(clearUserInfo());
    navigate("/")
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="relative hidden sm:flex items-center gap-2 ml-6 cursor-pointer"
      ref={dropdownRef}
      onClick={handleDropdownToggle}
    >
      <button
        className="flex items-center focus:outline-none bg-white rounded-full border-4 w-12 h-12 border-profile shadow-sm justify-center"
      >
        {profile_image && isValidProfileImage ? (
          <img src={profile_image} className="rounded-full" alt="user" />
        ) : (
          <div className="rounded-full flex items-center justify-center shadow-md cursor-pointer">
            <span
              className={`text-profile ${getShorthandName(name || "").length > 2 ? "text-f12" : "text-f14"
                }`}
            >
              {getShorthandName(name || "")}
            </span>
          </div>
        )}
      </button>

      {showDetails && (
        <div className="flex gap-2 items-center">
        <div className="text-left sm:hidden md:block">
          <p className="text-[14px] text-[#3C4848]">{name}</p>
          <p className="text-[12px] text-[#777F7F]">{email}</p>
        </div>
        <DownArrowEnt/>
        </div>
      )}

      {isOpen && (
        <div
          className={`absolute ${showDetails? "left-0" : "right-0"} top-full mt-3 py-2 w-48 bg-white rounded shadow-lg text-left z-50`}
        >
          <span className="block px-4 py-2 text-secondary text-f12 text-left">
            {name}
            <br />
          </span>
          <div className="border-t border-gray-300" />
          {!showDetails && <Link
            to="/dashboard"
            className="block px-4 py-2 text-secondarytwo hover:bg-gray-200 cursor-pointer text-f14"
          >
            Dashboard
          </Link>}
          <button
            onClick={handleLogout}
            className="block w-full px-4 py-2 text-secondarytwo hover:bg-gray-200 cursor-pointer text-f14 text-left"
          >
            Log out
          </button>
        </div>
      )}
    </div>

  );
};

export default UserProfileDropdown;
